module.exports = __webpack_public_path__ + "static/IMG_0066-a6b3a2883c94201063d38fc82daeaa70.jpg";